

<app-header></app-header>
<app-right-side></app-right-side>

<div class="container" >
    <div class="row">
        <div class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12" style="top:0px">
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <h6 class="title" style="color: var(--text-color)"><i class="fad fa-id-card"></i>&nbsp;Personal Information</h6>
                </div>
                <div class="ui-block-content">
                    <!-- Personal Information Form  -->
                    <form *ngIf="updateForm" [formGroup]="updateForm" (ngSubmit)="updateProfile()">
                        <div class="row">
                            <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label "style="color: var(--text-color)">Your Email <span style="color: red;"> *
                                        </span></label>
                                    <input class="form-control" type="email" name="email" formControlName="email" placeholder="" readonly style="background-color: var(--background-color); color: var(--text-color);">
                                </div>
                            </div>
                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)">First & Middle Name <span style="color: red;"> *
                                        </span></label>
                                    <input class="form-control" placeholder="First & last Name" name="fullName" formControlName="fullName" pattern="[a-zA-Z ]*" readonly type="text" style="background-color: var(--background-color); color: var(--text-color);">
                                </div>
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)">Your Gender </label>
                                    <input class="form-control" formControlName="gender" type="text" value="" readonly style="background-color: var(--background-color); color: var(--text-color);">
                                </div>
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)">Martial Status</label>
                                    <select class="form-control" formControlName="martialStatus" style="background-color: var(--background-color); color: var(--text-color);">
                                        <option value="Married">Married</option>
                                        <option value="Single">Single</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)">Residence</label>
                                    <select name="residentCountry" id="residentCountry" class="form-control" formControlName="residentCountry" style="background-color: var(--background-color); color: var(--text-color);">
                                        <option *ngFor="let country of countryList" [value]="country.name">
                                            {{country.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)">Last Name <span style="color: red;"> *
                                        </span></label>
                                    <input class="form-control" formControlName="lastName" placeholder="Last Name" type="text" value="" readonly style="background-color: var(--background-color); color: var(--text-color);">
                                </div>
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)"> Date of Birth</label>
                                    <input class="form-control" formControlName="dob" type="text" value="{{currentUser.success.user.dob}}" readonly style="background-color: var(--background-color); color: var(--text-color);">
                                </div>
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)">Nationality</label>
                                    <input class="form-control" formControlName="countryName" type="text" value="" readonly style="background-color: var(--background-color); color: var(--text-color);">
                                </div>

                                <div class="form-group">
                                    <label class="control-label" style="padding-left: 12px; color: var(--text-color);">Mobile Number <span
                                            style="color: red;"> *
                                        </span></label>
                                    <input class="form-control" readonly value="+{{currentUser.success.user.IsdCode}} {{currentUser.success.user.mobileNumber}}" formControlName="" style="background-color: var(--background-color); color: var(--text-color);">
                                </div>
                            </div>
                            <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label" style="color: var(--text-color)">Introduction</label>
                                    <textarea class="form-control" placeholder="Write a little description about you" value="" formControlName="about" style="background-color: var(--background-color); color: var(--text-color);"></textarea>
                                </div>
                            </div>
                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group with-icon label-floating">

                                    <input class="form-control" placeholder="Enter Your facebook Url" type="text" value="{{ currentUser.success.user.facebook}}" formControlName="facebook" style="background-color: var(--background-color); color: var(--text-color);">
                                    <i class="fab fa-facebook-f c-facebook" aria-hidden="true" ></i>
                                </div>
                                <div class="form-group with-icon label-floating">

                                    <input class="form-control" placeholder="Enter Your Twitter Url" type="text" value="{{ currentUser.success.user.twitter}}" formControlName="twitter" style="background-color: var(--background-color); color: var(--text-color);">
                                    <i class="fab fa-twitter c-twitter" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div *ngIf="errorMessage != ''" class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div *ngIf="errorMessage != ''" class="alert alert-danger" role="alert">
                                    {{errorMessage}}
                                </div>
                            </div>
                            <div class="col col-lg-2 col-md-6 col-sm-12 col-12">
                                <button class="btn btn-primar1y btn-l1g full-w1idth" style="background-color: rgb(0, 0, 0); color: #fff; font-size: 15px; width: 130px; text-align: center;">Save</button>
                            </div>
                            <div class="col col-lg-2 col-md-6 col-sm-12 col-12">
                                <button (click)="reLoad()" class="btn btn-primar1y btn-lg1 full-w1idth" style="background-color: rgb(146, 11, 11); color: #fff; font-size: 15px; width: 130px; text-align: center;">Restore</button>
                            </div>
                            
                        </div>
                    </form>
                    <!-- ... end Personal Information Form  -->
                </div>
            </div>
        </div>

        <div class="col col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12 responsive-display-none" style="top:0px">
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">

                <!-- Your Profile  -->

                <div class="your-profile" >
                    <!-- <div class="ui-block-title ui-block-title-small">
                        <h6 class="title">Your PROFILE</h6>
                    </div> -->

                    <div id="accordion" role="tablist" aria-multiselectable="true" >
                        <div class="card" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                            <div class="card-header" role="tab" id="headingOne">
                                <h6>
                                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" dir="ltr">
                                        <i class="fad fa-user-cog"></i>&nbsp;Profile Settings
                                    </a>
                                </h6>
                            </div>

                            <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                                <ul class="your-profile-menu">
                                    <li>
                                        <a routerLink="/profile-setting" style="color: var(--text-color);"><i class="fad fa-id-card"></i>&nbsp;Personal Information</a>
                                    </li>

                                    <li>
                                        <a routerLink="/change-password" style="color: var(--text-color);"><i class="fad fa-lock"></i>&nbsp;Change Password</a>
                                    </li>
                                    <li>
                                        <a routerLink="/hobbies-and-intrests" style="color: var(--text-color);"><i class="fad fa-icons"></i>&nbsp;Hobbies and Interests</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ui-block-title">
                        <a routerLink="/friend-requests" class="h6 title"><i class="fad fa-user-clock"></i>&nbsp;Friend Requests</a>
                        <!-- <a routerLink="/friend-requests" class="items-round-little bg-blue">4</a> -->
                    </div>
                    <!-- <div class="ui-block-title ui-block-title-small">
						<h6 class="title">FAVOURITE PAGE</h6>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Create Fav Page</a>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Fav Page Settings</a>
					</div> -->
                </div>

                <!-- ... end Your Profile  -->

            </div>
        </div>
    </div>
</div>

<!-- ... end Your Account Personal Information -->